import React from 'react';
import { Clock } from 'lucide-react';
import FormField from './FormField';
import { TIME_SLOTS } from '../../utils/bookingValidation';

/** Stay-duration picker, identical on the customer page and in the admin modal. */
const DurationSelector = ({ value, onChange, disabled = false, hint = 'Select the expected stay duration' }) => (
  <FormField
    label={<><Clock className="w-4 h-4 inline mr-1" />Duration</>}
    required
    hint={hint}
  >
    <div className="grid grid-cols-6 gap-1.5">
      {TIME_SLOTS.map((slot) => {
        const active = value === slot.value;
        return (
          <button
            key={slot.value}
            type="button"
            onClick={() => onChange(slot.value)}
            disabled={disabled}
            aria-pressed={active}
            className={`py-2.5 px-1 rounded-lg text-center transition-all border-2 disabled:cursor-not-allowed ${
              active
                ? 'bg-railway-500 border-railway-500 text-white shadow-lg'
                : 'bg-white border-midnight-200 text-midnight-700 hover:border-railway-300 hover:bg-railway-50'
            }`}
          >
            <div className="text-base font-bold leading-none">{slot.hours}</div>
            <div className="text-[10px] opacity-80 mt-0.5">{slot.hours === 1 ? 'hour' : 'hours'}</div>
          </button>
        );
      })}
    </div>
  </FormField>
);

export default DurationSelector;
